import { isBase64Image } from '../../../lib/utils.js';

const getDuplicateCustomNames = (customNames) => {
  // Filter out keys with empty values
  const nonEmptyNames = Object.fromEntries(
    Object.entries(customNames).filter(
      ([key, value]) => value !== '' && value !== undefined
    )
  );

  // Create a map to track duplicates and an array for duplicate keys
  const valueMap = {};
  const duplicateKeys = [];

  // Iterate through the filtered non-empty names
  Object.entries(nonEmptyNames).forEach(([key, value]) => {
    if (value in valueMap) {
      // If the value already exists in the map, add both keys to duplicates
      if (!duplicateKeys.includes(valueMap[value])) {
        duplicateKeys.push(valueMap[value]);
      }
      duplicateKeys.push(key);
    } else {
      valueMap[value] = key;
    }
  });

  return duplicateKeys;
};

export const customCompanySettingsValidate = (
  values,
  imageSize,
  selectedImage,
  iconSize,
  selectedIcon
) => {
  const errors = {};

  const customNames = {
    customPortfolioName: (values.customPortfolioName || 'portfolio')
      .toLowerCase()
      .trim(),
    customProjectName: (values.customProjectName || 'project')
      .toLowerCase()
      .trim(),
    customInitiativeName: (values.customInitiativeName || 'initiative')
      .toLowerCase()
      .trim(),
    customActivityName: (values.customActivityName || 'activity')
      .toLowerCase()
      .trim(),
  };

  getDuplicateCustomNames(customNames).forEach((key) => {
    errors[key] = 'Name should be unique';
  });

  if (values.useOktaSso) {
    if (!values.clientId) {
      errors.clientId = 'Client ID is required';
    }

    if (!values.issuerUri) {
      errors.issuerUri = 'Issuer URI is required';
    }
  }

  if (values.customActivityName?.length > 30) {
    errors.customActivityName = 'Maximum 30 characters allowed';
  }

  if (values.customActivityName?.length > 30) {
    errors.customActivityName = 'Maximum 30 characters allowed';
  }

  if (values.customInitiativeName?.length > 30) {
    errors.customInitiativeName = 'Maximum 30 characters allowed';
  }

  if (values.customProjectName?.length > 30) {
    errors.customProjectName = 'Maximum 30 characters allowed';
  }

  if (values.customPortfolioName?.length > 30) {
    errors.customPortfolioName = 'Maximum 30 characters allowed';
  }

  if (selectedImage && imageSize) {
    if (!isBase64Image(selectedImage)) {
      errors.logos = 'Allowed formats: .jpeg, .png, .jpg';
    }
  }

  if (selectedImage && imageSize > 10485760) {
    errors.logos = 'Max file size: 10Mb';
  }

  if (selectedIcon && iconSize) {
    if (!isBase64Image(selectedIcon)) {
      errors.icon = 'Allowed formats: .jpeg, .png, .jpg';
    }
  }

  if (selectedIcon && iconSize > 10485760) {
    errors.icon = 'Max file size: 10Mb';
  }

  return errors;
};
